import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("ke_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const path = window.location.pathname;
    if (status === 401 && path.startsWith("/drift") && !path.includes("/drift/login")) {
      localStorage.removeItem("ke_token");
      window.location.href = "/drift/login";
    }
    return Promise.reject(err);
  }
);

export const fileUrl = (id, download = false) => `${API}/files/${id}${download ? "?download=1" : ""}`;

export const errMsg = (e, fallback) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(", ");
  return fallback || "Noko gjekk gale. Prøv igjen.";
};
